



























































































































import { Vue, Component, Lifecycle, Prop, p, Mixin } from "av-ts";
import { INotification } from "../../interfaces/models";

import UserService from "../../services/UserService";
import responsiveMixin from "../../responsiveMixin";
import Fetcher from "../../services/Fetcher";
import { serverToLocal } from "../../util";

@Component
export default class Notifications extends mixin(responsiveMixin, Vue) {
    @Prop
    showCount = p<number>({
        default: 15
    });

    pNotifications: INotification[] = [];
    updateNotifications(newNotifications: INotification[]) {
        this.pNotifications = newNotifications.slice(0, this.showCount);
        if (newNotifications.length > this.showCount) {
            for (let n of newNotifications.slice(this.showCount)) {
                if (n.read == false) {
                    this.pNotifications.push(n);
                }
            }
        }
    };

    date = new Date();

    @Lifecycle
    created() {
        Fetcher.get(UserService.getUserNotifications)
            .on(this.updateNotifications);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getUserNotifications)
            .off(this.updateNotifications);
    }

    notificationDate(notification: INotification) {
        return serverToLocal(<number> notification.created);
    }

    get notifications() {
        return this.pNotifications;
    }

    redir(link: string) {
        this.$router.push(link);
    }

    read(read: boolean, id: number) {
        if (!read) {
            UserService.markNotificationAsRead(id);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/Notifications.vue